import { SquareLogo } from './logos/square-logo';
import { PaypalLogo } from './logos/paypal-logo';
import { NasaLogo } from './logos/nasa-logo';
import { FordLogo } from './logos/ford-logo';
import { EbayLogo } from './logos/ebay-logo';
import { DominosLogo } from './logos/dominos-logo';
import { CiscoLogo } from './logos/cisco-logo';
import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';

const carouselCss = css({
	overflow: 'hidden',
	height: '35px',
	position: 'relative',
	width: '100%',
	[media.below.md]: {
		display: 'none',
	},
});

const trackCss = css({
	['@keyframes scroll']: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		from: {
			transform: 'translateX(0)',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		to: {
			transform: 'translateX(-50%)',
		},
	},
	animation: 'scroll 11s linear infinite',
	display: 'flex',
	position: 'absolute',
});

const imageCss = css({
	display: 'flex',
	height: '35px',
	width: '70px',
	marginInlineEnd: '32px',
});

const logos = [DominosLogo, SquareLogo, EbayLogo, CiscoLogo, FordLogo, PaypalLogo, NasaLogo];

export const AnimatedSocialProof = () => (
	<div css={carouselCss} data-testid="animated-social-proof">
		<div css={trackCss}>
			{[...logos, ...logos].map((Logo, index) => (
				<div key={index} css={imageCss}>
					<Logo />
				</div>
			))}
		</div>
	</div>
);
